import { initialState } from "../../initial_state";
import update from "immutability-helper";
import * as actionTypes from "../../action-types";

export default (state = initialState, action) => {
  let newState = Object.assign({}, state);
  switch (action.type) {
    case actionTypes.PERMISO_ADMIN_LOAD_ANNOUNCEMENTS:
      newState = update(state, {
        $set: action.payload,
      });
      return newState;
    default:
      return state;
  }
};
